<template>
  <div class="variant-wrapper avoid-break-inside">
    <div class="columns is-gapless is-size-6 variant box is-mobile is-marginless" @click="addToCart">
      <div class="column is-12-mobile is-11-tablet is-12-desktop is-11-widescreen">
        <div class="columns is-mobile is-multiline">
          <div class="column is-5-widescreen is-12-desktop is-6-mobile is-size-7-mobile">
            <!-- <p v-if="variant.available <= 10 && variant.available > 0" class="mb-2">
              <b-tag type="is-dark">{{ $t('product.pieces-available', {pcs: variant.available}) }}</b-tag>
            </p>
            <p v-if="variant.available > 10" class="mb-2">
              <b-tag type="is-dark">{{ $t('product.limited-quantities-available') }}</b-tag>
            </p> -->

            <p class="mb-2">
              <b-tag v-if="variant.available <= 10 && variant.available > 0" type="is-dark">{{ $t('product.pieces-available', {pcs: variant.available}) }}</b-tag>
              <b-tag v-else type="is-dark">{{ $t('product.limited-quantities-available') }}</b-tag>
            </p>

            <span class="is-inline-block" v-if="variant.nights == 1">{{ variant.nights }} {{ $t('general.night') }}, {{ variant.persons }} {{ $t('general.persons') }}, </span>
            <span class="is-inline-block" v-if="variant.nights > 1">{{ variant.nights }} {{ $t('general.nights') }}, {{ variant.persons }} {{ $t('general.persons') }}, </span>&nbsp; <span class="is-inline-block">{{ variant.room.name }}, {{ variant.board.longName }}</span>
            <span class="is-inline-block" v-show="variant.additional && variant.additional.length > 0">{{ variant.additional }}</span>
          </div>
          <div class="column is-7-widescreen is-12-desktop is-6-mobile" style="position:relative;">
            <section class="is-small has-text-right">
              <span class="is-hidden-mobile" v-if="$whitelabel.showReduction && variant.persons == 2"> {{ $t('general.instead-of') }} {{ (variant.price.list / variant.persons) | amount }} </span>
              <span class="is-hidden-mobile" v-if="$whitelabel.showReduction && variant.persons != 2"> {{ $t('general.instead-of') }} {{ variant.price.list | amount }} </span>
              <ReductionDisplay :beforePrice="variant.price.list" v-if="$whitelabel.showReduction" :afterPrice="variant.price.total" style="margin-left:.5em;" />

              <!-- <span v-if="reductionInfo.hasActiveReduction"> statt {{ variant.price.display | amount }} </span>
              <ReductionDisplay :beforePrice="variant.price.display" v-if="reductionInfo.hasActiveReduction" :afterPrice="displayPrice" style="margin-left:.5em;" /> -->

              <p class="has-text-weight-bold has-size-7-mobile">
                <span class="is-size-7-mobile is-inline-block">{{ variant.price.prefix }}</span>
                <span class="is-inline-block is-size-3 is-size-4-mobile ml-2">{{ variant.price.currency | currency }} {{ displayPrice | amount }}</span>
              </p>
              <p class="is-size-7" v-if="reductionInfo.hasActiveReduction">
                {{ $t('product.with-promotioncode-price') }} {{ variant.price.display | amount }} (<ReductionDisplay :beforePrice="variant.price.display" v-if="reductionInfo.hasActiveReduction" :afterPrice="displayPrice" :textOnly="true" />)
              </p>
            </section>
            <div class="variant-actions is-hidden-touch">
              <b-button type="is-primary" size="is-medium" :disabled="variant.available < 1">{{ $t('general.add-to-cart') }}</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="column variant-chevron is-1 is-hidden-mobile is-hidden-desktop-only	">
        <b-icon class="has-text-primary" icon="chevron-right" size="is-large"> </b-icon>
      </div>
    </div>

    <b-notification v-if="variant.available <= 0" aria-close-label="Close notification" :closable="false" class="has-text-weight-bold variant-notification is-size-5 is-uppercase has-text-centered" role="alert">
      {{ $t('notices.voucher-sold-out') }}
    </b-notification>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {GuardFactory} from '@/api/guard-provider'
import ReductionDisplay from '@/components/ReductionDisplay'
export default {
  name: 'VariantDisplay',
  components: {
    ReductionDisplay,
  },
  props: {
    variant: Object,
    services: String,
  },
  computed: {
    compiledMarkdown: function() {
      // eslint-disable-next-line
      return marked(this.services, {sanitize: true})
    },
    ...mapGetters({
      reductionInfo: 'displayReduction',
    }),
    displayPrice() {
      if (this.reductionInfo.hasActiveReduction) {
        return this.reductionInfo.reductionFx(this.variant.price.display)
      } else {
        return this.variant.price.display
      }
    },
  },
  methods: {
    ...mapActions(['addProduct']),
    async addToCart() {
      if (await GuardFactory().isClear()) {
        await this.addProduct(this.variant.id)
        this.$store.dispatch('showDrawer')
      } else {
        this.$store.dispatch('setGuardActive')
      }

      this.$emit('variantToCart', false)
      //this.$router.push({ name: "checkout" });
    },
  },
}
</script>

<style scoped lang="scss">
.variant-wrapper {
  position: relative;
}

.variant {
  transition: all 200ms ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.025);

    .outside-viewport & {
      transform: none;
    }
  }
}

.variant-actions {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  opacity: 0;
  transition: opacity 200ms ease-in-out;
  justify-content: flex-end;
  align-items: center;

  @media screen and (min-width: 1024px) {
    .variant:hover & {
      opacity: 1;
    }
  }
}

.variant-notification {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2em 1em;
  opacity: 0.85;
}

.variant-chevron {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: 0;
  transform: scale(0.5);
  //transform: translateX(1em);

  @media screen and (min-width: 480px) {
    position: static;
    transform: scale(1);
  }

  @media screen and (min-width: 1024px) {
    transform: translateX(0.5em);
    transition: transform 200ms ease-in-out;

    .variant-wrapper:hover & {
      //transform:  translateY(-50%) translateX(1em);
      transform: translateX(1em);
    }
  }

  .outside-viewport .variant-wrapper:hover & {
    transform: none;
  }
}
</style>
